import React, { ReactElement } from 'react';
import { useDispatch } from 'react-redux';

import Icon from '../../../../../../components/icons/Icon';
import SheetContainer, { Content, Overlay, Sheet } from '../../../../../../mobile/structural/sheet';
import { UseSheetReturnType } from '../../../../../../mobile/structural/sheet/hooks/useSheet';
import SheetMenu, { SheetMenuItem } from '../../../../../../mobile/structural/sheet/menu/SheetMenu';
import { openSheet } from '../../../../../../mobile/structural/sheet/sheetActions';
import { SheetId } from '../../../../../../mobile/structural/sheet/sheetTypes';
import { Label } from '../../../../../../../common/labels/labelTypes';
import { useTranslator } from '../../../../../../components/i18n/useTranslator';
import LabelUsageText from '../labelUsage/LabelUsageText';
import { LabelUsageDataState } from '../labelUsage/useLabelUsageData';

import './LabelActionsSheet.scss';

type LabelActionsSheetProps = {
    label: Label;
    onDeleteClick: () => void;
    onEditClick: () => void;
    sheetProps: UseSheetReturnType;
    usageDataState: LabelUsageDataState;
};

const LabelActionsSheet = ({
    label,
    onDeleteClick,
    onEditClick,
    sheetProps,
    usageDataState,
}: LabelActionsSheetProps): ReactElement => {
    const dispatch = useDispatch();
    const translate = useTranslator('popup', 'labels.edit');

    const menuItems: SheetMenuItem[] = [
        {
            label: translate('heading'),
            icon: <Icon name="toolbar-label" />,
            onClick: onEditClick,
        },
        {
            label: translate('delete'),
            icon: <Icon name="context-menu-trash" />,
            onClick: onDeleteClick,
        },
    ];

    const handleOpenLabelSearch = (event: React.MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault();

        dispatch(
            openSheet(SheetId.SearchTool, undefined, {
                data: { initialSearchText: label.name, labelId: label._id },
            }),
        );
    };

    return (
        <SheetContainer className="LabelActionsSheet" {...sheetProps} defaultSnapPoint={'0.5max'}>
            <Overlay />
            <Sheet>
                <Content>
                    <SheetMenu
                        menuItems={menuItems}
                        footer={
                            <LabelUsageText
                                onUsageLinkClick={handleOpenLabelSearch}
                                usageDataState={usageDataState}
                                className="p-[1rem] text-center"
                            />
                        }
                    />
                </Content>
            </Sheet>
        </SheetContainer>
    );
};

export default LabelActionsSheet;
